// Module
var code = "<div id=\"V-61D06FA6-55BC-460B-AD65-968E35CE8CD5\" data-b-class-hidden=\"{Binding isselected,Converter:notConverter}\"> <div class=\"V-19FDE238-3CA1-481D-AE65-E57F1EA9F607 bodyContainer\" data-b-content=\"{Binding element}\"></div> </div> ";
// Exports
export default code;